import { createContext, useContext, useState, type ReactNode } from 'react';

type AuthView = 'login' | 'register' | 'forgot-password' | null;

interface AuthModalContextType {
    view: AuthView;
    openLogin: () => void;
    openRegister: () => void;
    openForgotPassword: () => void;
    close: () => void;
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);

export const AuthModalProvider = ({ children }: { children: ReactNode }) => {
    const [view, setView] = useState<AuthView>(null);

    const openLogin = () => setView('login');
    const openRegister = () => setView('register');
    const openForgotPassword = () => setView('forgot-password');
    const close = () => setView(null);

    return (
        <AuthModalContext.Provider value={{ view, openLogin, openRegister, openForgotPassword, close }}>
            {children}
        </AuthModalContext.Provider>
    );
};

export const useAuthModal = () => {
    const context = useContext(AuthModalContext);
    if (!context) {
        throw new Error('useAuthModal must be used within an AuthModalProvider');
    }
    return context;
};
